module.exports = "../../app/cells/pages/question/insights_cell.rb";